<script setup lang="ts">
import { Crosshair } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import { onMounted } from 'vue';
import {
    currentUserLat, currentUserLng,
    overrideCurrentUserLat, overrideCurrentUserLng,
    pointChanged
} from '@deliveryteam-spa-orders-vue/refs/UserCurrentLocation';
import { useMyOrdersMap } from '@deliveryteam-spa-orders-vue/composables/useMyOrdersMap';

const mapId = `my-orders-map-${Math.random().toString(36).slice(2, 11)}`;

const { initMap, getMapCenter, redraw } = useMyOrdersMap(currentUserLat, currentUserLng);

const overrideCurrentUserLocation = () => {
    if (!IS_DEV) return;
    const center = getMapCenter();
    if (center) {
        overrideCurrentUserLat.value = center.lat;
        overrideCurrentUserLng.value = center.lng;
        pointChanged(center.lat, center.lng);
        redraw();
    }
};

const IS_DEV = import.meta.env.DEV;

onMounted(() => {
    void initMap(mapId);
});
</script>

<template>
    <div :id="mapId"
         class="relative w-full h-[50vh] min-h-[220px] md:min-h-[320px] z-0 dark:invert dark:hue-rotate-180">
        <Button v-if="IS_DEV"
                type="button"
                variant="outline"
                class="absolute right-1 top-1 z-[1001] h-9 w-9 p-0"
                aria-label="Dev: use map center as watched GPS location"
                @click="overrideCurrentUserLocation">
            <Crosshair class="h-4 w-4" />
        </Button>
    </div>
</template>
